import React from 'react';
import {
	NavLink,
	Link
} from 'react-router-dom'


class Menu extends React.Component {
	constructor(props) {
		super(props);
	}

	componentDidMount(){
		// adjust fullscreen height
		let vh = window.innerHeight * 0.01;
		document.documentElement.style.setProperty('--vh', `${vh}px`);
		window.addEventListener('resize', () => {
			let vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${vh}px`);
		});

		// toggle submenu
		let mainmenu = document.querySelector('.mainmenu');
		let allSubmenu = document.querySelectorAll('.has-submenu');
		Array.from(allSubmenu).forEach(function(submenu){
			submenu.addEventListener('click', function(e){
				mainmenu.classList.toggle('is-actv');
				if(e.target.getAttribute('data-name')){
					Array.from(mainmenu.childNodes).forEach((elem) => {
						elem.classList.remove('actv')
					})
					let targetName = this.getAttribute('data-submenu');
					document.getElementById(targetName).classList.toggle('is-showing');
					this.classList.toggle('actv');
				}
			});
		});
	
		
		// toggle menu
		let toggleMenu = document.querySelectorAll('.toggle-menu');
		let hasSubMenu = document.querySelector('.has-submenu');
		let subMenu = document.querySelector('.submenu');
		let nav = document.querySelector('nav');
		let root = document.querySelector('html')
		root.classList.remove('bound');

		if(nav){
			Array.from(toggleMenu).forEach(function(tm){
				tm.addEventListener('click', function(){
					if(nav.classList.contains('is-open')){
						hasSubMenu.classList.remove('actv');
					}
					root.classList.toggle('bound');
					nav.classList.toggle('is-open');
					mainmenu.classList.remove('is-actv');
					//hasSubMenu.classList.remove('actv');
					//subMenu.classList.remove('is-showing');
				});
			});
		}

		if(subMenu){
			Array.from(subMenu.childNodes).forEach(function(tm){
				tm.addEventListener('click', function(){
					root.classList.toggle('bound');
					nav.classList.toggle('is-open');
					mainmenu.classList.remove('is-actv');
					//hasSubMenu.classList.remove('actv');
					//subMenu.classList.remove('is-showing');
				});
			})
		}
		
	}

	getNavLinkClass = (path) => {
		let pathArr = this.props.location.pathname.split('/');
		return pathArr[pathArr.length-2] === path.replace('/','') ? 'actv' : '';
	}

	render() {
		let { options } = this.props.options;
		let contact_number = !(contact_number in options) ? options.contact_number : '';
		let contact_email = !(contact_email in options) ? options.contact_email : '';
		let instagram_url = !(instagram_url in options) ? options.instagram_url : '';
		let twitter_url = !(twitter_url in options) ? options.twitter_url : '';

		let { menu } = this.props.menu;
		let _this = this;
		let cls = 'submenu';
		let pathArr = this.props.location.pathname.split('/');

		//if(!menu.primary) return [];
		let menu_html = Object.keys(menu.primary).map((index) => {
			let item = menu.primary[index];
			let slug = item.url.replace(process.env.REACT_APP_WP_URL, '');
			let submenu_attr = {};
			let sub_menu_html = '';
			let menu_color = {'--libgClr': item.color};
			if(item.child_items.length){
				//console.log(slug.replace('/',''))
				let actvCls = pathArr.length && pathArr[pathArr.length-3] == slug.replace('/','') ? "has-submenu actv" : 'has-submenu';
				submenu_attr = {className: actvCls, 'data-submenu':slug};
				if(pathArr.length && pathArr[pathArr.length-3] == slug.replace('/','')){
					cls = 'submenu is-showing';
					//submenu_attr.className = "has-submenu actv";
				}
				sub_menu_html = item.child_items.map((sub_item, sub_index) => {
					let sub_slug = sub_item.url.replace(process.env.REACT_APP_WP_URL, '');
					return (
						<li key={sub_index}>
							<NavLink activeClassName="subnav-actv" exact to={`${process.env.PUBLIC_URL}/${sub_slug}`}>{sub_item.title}</NavLink>
						</li>
					);
				})
			}

			return (
				item.child_items.length ?
					<li style={menu_color} {...submenu_attr}  key={index}>
						<a activeClassName="nav-actv" href="javascript:void(0)" data-name={item.title}></a>
						<ul className={cls} id={slug}>	
							{sub_menu_html}
						</ul>
					</li>
				:	
					<li style={menu_color} className={_this.getNavLinkClass(slug)} key={index}>
						<NavLink activeClassName="subnav-actv" exact to={`${process.env.PUBLIC_URL}/${slug}`}  data-name={item.title}></NavLink>
					</li>
			);
			
		})
		return (
			<nav>
				<div className="main-container posiR">
					<div className="grid">
						<div className="contentArea">
							<NavLink className="--logo" exact to={`${process.env.PUBLIC_URL}/`}>
								<img src={options.logo_image} alt="Le Lay Architects" title="Le Lay Architects" />
							</NavLink>
							<div>
								<p>{options.office_details}</p>
								<div dangerouslySetInnerHTML={{ __html: options.office_address }} />
								<br /><br />
								<p><a href={`mailto:${options.contact_email}`}>{options.contact_email}</a></p>
								<p><a href={`tel:${options.contact_number}`}>{options.contact_number}</a></p>
								<p><a href={options.twitter_url} target="_blank">LinkedIn</a> / <a href={options.instagram_url} target="_blank">Instagram</a></p>
							</div>
						</div>
						<div className="contentArea">
							<ul className="mainmenu">
								{menu_html}
							</ul>
						</div>
						<a href="javascript:" className="btn-closemenu toggle-menu"></a>
					</div>
				</div>
			</nav>
		);
	}
}

export default Menu;


// WEBPACK FOOTER //
// ./src/components/Menu.js